import { observer } from 'mobx-react-lite';
import queryString from 'query-string';
import React, { useContext, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Container } from 'semantic-ui-react';

import { history } from '../..';
import LoadingComponent from '../../app/layout/LoadingComponent';
import LoginComponent from '../../app/layout/LoginComponent';
import { LoginValues } from '../../app/models/login';
import { RootStoreContext } from '../../app/stores/rootStore';

const LunaSeaAuth: React.FC<RouteComponentProps> = ({ location }) => {
  const rootStore = useContext(RootStoreContext);
  const { setSession } = rootStore.sessionStore;
  const { loginLunaSeaAuth } = rootStore.memberStore;

  const { client_id, callback_url, auth_params, fanclub, id_text, pass_text } = queryString.parse(location.search);

  const [appLoaded, setAppLoaded] = useState(false);
  const [sessionId, setSessionId] = useState('');

  const [formValues, setFormValues] = useState(new LoginValues());

  useEffect(() => {
    try {
      (async () => {
        // セッション保持
        const session = await setSession({
          session_id: '',
          client_id: client_id as string,
          auth_params: auth_params as string,
          callback_url: callback_url as string,
        });
        setSessionId(session.session_id);
        setAppLoaded(true);
      })();
    } catch (error) {
      history.push('/error');
    }
  }, [auth_params, callback_url, client_id, setSession]);

  if (!appLoaded) return <LoadingComponent content="Loading..." />;

  let invalidCredentialsMessage = '';
  if (id_text) {
    invalidCredentialsMessage += `${id_text}または`;
  } else {
    invalidCredentialsMessage += '会員番号または';
  }
  if (pass_text) {
    invalidCredentialsMessage += `${pass_text}が正しくありません。`;
  } else {
    invalidCredentialsMessage += 'パスワードが正しくありません。';
  }

  return (
    <Container>
      <LoginComponent
        title=""
        description={fanclub ? `${fanclub}` : 'ファンクラブの会員番号とパスワードで認証してください。'}
        idPlaceholder={id_text ? `${id_text}` : '会員番号'}
        passwordPlaceholder={pass_text ? `${pass_text}` : 'パスワード'}
        invalidCredentialsMessage={invalidCredentialsMessage}
        userlockedMessage="アカウントがロックされました。時間を空けてから再度お試しください。"
        formValues={formValues}
        setFormValues={setFormValues}
        handleAuthenticate={async () => {
          // 認証先のパラメータを設定
          const { ...values } = formValues;
          values.session_id = sessionId;
          values.client_id = client_id as string;
          values.auth_params = auth_params as string;
          // 認証
          await loginLunaSeaAuth(values);
        }}
      />
    </Container>
  );
};

export default observer(LunaSeaAuth);
